import axios from 'axios'
import { IGNORE_SLOW_REQUEST_CONFIG } from '../util/operationProgressUtil'

export const ALERTAS_RECUPERADOS = '@alertasActions/ALERTAS_RECUPERADOS'
export const ALERTAS_MARCADAS_COMO_LIDAS = '@alertasActions/ALERTAS_MARCADAS_COMO_LIDAS'
export const ALERTA_PROCESSO_ATUALIZADO_RECUPERADO =
  '@alertasActions/ALERTA_PROCESSO_ATUALIZADO_RECUPERADO'
export const ALERTA_PROCESSO_ADM_ATUALIZADO_RECUPERADO =
  '@alertasActions/ALERTA_PROCESSO_ADM_ATUALIZADO_RECUPERADO'
export const ALERTA_DOCUMENTO_ATUALIZADO_RECUPERADO =
  '@alertasActions/ALERTA_DOCUMENTO_ATUALIZADO_RECUPERADO'
export const ALERTA_COMUNICACAO_ATUALIZADA_RECUPERADA =
  '@alertasActions/ALERTA_COMUNICACAO_ATUALIZADA_RECUPERADA'
export const ALERTA_COMUNICACAO_PROCESSUAL_CRIADA =
  '@alertasActions/ALERTA_COMUNICACAO_PROCESSUAL_CRIADA'

export const tratarProcessoAtualizado = (
  codigoProcesso,
  numeroFormatado,
  notificarUnidadesAtuais
) => ({
  type: ALERTA_PROCESSO_ATUALIZADO_RECUPERADO,
  payload: { codigoProcesso, numeroFormatado, notificarUnidadesAtuais }
})

export const tratarProcessoAdmAtualizado = (codigoProcesso, codigoUsuario) => ({
  type: ALERTA_PROCESSO_ADM_ATUALIZADO_RECUPERADO,
  payload: { codigoProcesso, codigoUsuario }
})

export const tratarComunicacaoProcessualCriada = (
  codigoProcesso,
  codigoComunicacao,
  codigoUsuario
) => ({
  type: ALERTA_COMUNICACAO_PROCESSUAL_CRIADA,
  payload: { codigoProcesso, codigoComunicacao, codigoUsuario }
})

export const tratarDocumentoAtualizado = (codigoDocumento, codigoUsuario) => ({
  type: ALERTA_DOCUMENTO_ATUALIZADO_RECUPERADO,
  payload: { codigoDocumento, codigoUsuario }
})

export const tratarComunicacaoAtualizada = (codigoComunicacao, codigoUsuario) => ({
  type: ALERTA_COMUNICACAO_ATUALIZADA_RECUPERADA,
  payload: { codigoComunicacao, codigoUsuario }
})

export const recuperarAlertas = () => {
  return (dispatch) =>
    axios.get(`/bff/notificacoes-usuario`, IGNORE_SLOW_REQUEST_CONFIG).then((response) =>
      dispatch({
        type: ALERTAS_RECUPERADOS,
        payload: response.data
      })
    )
}

export const marcarAlertasComoLidas = (codigosNotificacoesLidas) => {
  return (dispatch) =>
    axios
      .post(`/bff/notificacoes-usuario/marcar-lidas`, { codigos: codigosNotificacoesLidas })
      .then((response) =>
        dispatch({
          type: ALERTAS_MARCADAS_COMO_LIDAS
        })
      )
}
